import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Conectividad/comprobarDisponibilidadVPN`, method: 'POST', body: values, token: token})
}